L.Control.Group = L.Control.extend({
  options: {
    position: 'topleft',
    collapsed: true,
    controlClassesToToggle: [],
    controlButton: {
      title: "Группа"
    }
  },

  onRemove: function(map) {
    this._container = null
  },

  onAdd: function (map) {

    this._map = map
    let container = this._container = L.DomUtil.create('div', 'leaflet-control-group group-container')
    this._initToggle()

    return container
  },

  _initToggle: function() {

    let container = this._container

    //Makes this work on IE10 Touch devices by stopping it from firing a mouseout event when the touch is released
    container.setAttribute('aria-haspopup', true)

    if (!L.Browser.touch) {
      L.DomEvent
        .disableClickPropagation(container)
      //.disableScrollPropagation(container)
    } else {
      L.DomEvent.on(container, 'click', L.DomEvent.stopPropagation)
    }

    if (this.options.collapsed) {
      let link = L.DomUtil.create('a', " group-toggle", container)
      this._icon = L.DomUtil.create('i', "Icon", link)
      link.href = '#'
      link.title = this.options.controlButton.title
      L.DomEvent
        .on(link, 'click', this._toggle, this)
      this._collapse()

    }
  },

  _toggle: function() {
    if (this._container.classList.contains('group-collapsed')) {
      this._expand()
    } else {
      this._collapse()
    }
  },

  _expand: function() {
    this._icon.classList.remove('IconBurger')
    this._icon.classList.add('IconClose')
    this._container.className = this._container.className.replace('group-collapsed', '')
    this.options.controlClassesToToggle.forEach(v => {
      this._map._container.getElementsByClassName(v)[0].classList.remove('Group-forceHide')
      //document.getElementsByClassName(v)[0].classList.remove('Group-forceHide')
    })
  },

  _collapse: function() {
    this._icon.classList.remove('IconClose')
    this._icon.classList.add('IconBurger')
    L.DomUtil.addClass(this._container, 'group-collapsed')
    this.options.controlClassesToToggle.forEach(v => {
      this._map._container.getElementsByClassName(v)[0].classList.add('Group-forceHide')
      //document.getElementsByClassName(v)[0].classList.add('Group-forceHide')
    })
  },
})

L.control.group = function(options) {
  return new L.Control.Group(options)
}



// WEBPACK FOOTER //
// ./src/helpers/leaflet-group.js